import { Goal } from '@griply/types';

export type GetGoalTaskListGoalsOptions = {
  isGoalGrouping: boolean;
};

export const getGoalTaskListGoals = (
  goal: Goal | undefined,
  subGoals: Goal[],
  { isGoalGrouping }: GetGoalTaskListGoalsOptions,
): Goal[] => {
  if (!goal) {
    return [];
  }

  const visibleSubGoals = subGoals.filter(
    (subGoal) =>
      !(
        isGoalGrouping &&
        (subGoal.archivedAt ||
          (goal.hideCompletedTasks &&
            !!subGoal.completedAt &&
            (subGoal.taskCount ?? 0) === (subGoal.completedTaskCount ?? 0)))
      ),
  );

  const goalSorting = goal.goalSorting;
  if (goalSorting?.length) {
    visibleSubGoals.sort(
      (a, b) =>
        (goalSorting.indexOf(a.id) + 1 || Number.MAX_VALUE) -
        (goalSorting.indexOf(b.id) + 1 || Number.MAX_VALUE),
    );
  }

  return [goal, ...visibleSubGoals];
};
